import { Markierung } from '@/domain/termine/components/Markierung/Markierung';
import { MitarbeiterSchichtenPopover } from '@/domain/termine/features/Calendar/shared/TerminInfo/Verknuepfungen/MitarbeiterSchichtenPopover';
import { markierungMapper } from '@/domain/termine/shared/types';
import { Schichten } from '@/domain/termine/shared/types/Schichten';
import { formatTimeRange } from '@/domain/termine/shared/utils/formatDateTime';

export function TerminVerknuepfungSchicht({
  schichten,
}: {
  schichten: Schichten[];
}) {
  return (
    <div className="max-h-60 overflow-y-auto">
      {schichten.map((schichten) => (
        <div key={schichten.id} className="pt-3">
          <div className="flex flex-col justify-between">
            <div>
              <span className="text-neutrals-900">{schichten.name}</span>
            </div>
            <div className="flex justify-between">
              <div className="flex items-center gap-1 text-xs font-normal text-neutrals-700">
                {schichten.markierung && (
                  <Markierung
                    color={markierungMapper[schichten.markierung].base}
                  />
                )}
                {schichten.arbeitsbereich.name} ⋅{' '}
                {formatTimeRange(schichten.beginn, schichten.ende)}
              </div>
              <MitarbeiterSchichtenPopover
                mitarbeiterListe={schichten.mitarbeiter}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
